module.exports = __webpack_public_path__ + "img/8.53531841.webp";